import FieldString from "./generic/string/string"
import FieldDropdown from "./generic/dropdown/dropdown"
import FieldCrmContact from "./system/crm/contact/crm-contact"
import FieldCrmContactType from "./system/crm/contact-type/contact-type"
import FieldFormula from "./generic/formula/formula"
import FieldProjectPriority from "./system/project/priority/priority"
import FieldEventType from "./system/event/type/type"
import FieldTaskType from "./system/task/task-type/task-type";
import FieldText from "./generic/text/text";
import FieldCheckbox from "./generic/boolean/checkbox/checkbox";
import FieldTaskPriority from "./system/task/priority/priority";
import FieldToggle from "./generic/boolean/toggle/toggle";
import FieldPhone from "./generic/info/phone/phone";
import FieldUrl from "./generic/info/url/url";
import FieldColor from "./generic/color/color";
import FieldEmail from "./generic/info/email/email";
import FieldNumber from "./generic/number/number";
import FieldCurrency from "./generic/finance/currency/currency";
import FieldPercentage from "./generic/percentage/percentage";
import FieldDate from "./generic/datetime/date/date";
import FieldRAG from "./generic/rag/rag";
import FieldProjectHealth from "./system/project/health/health";
import FieldDateRange from "./generic/datetime/date-range/date-range";
import FieldUser from "./generic/user/user";
import FieldTaskActionRequiredUser from "./system/task/user/action-required-user/action-required-user";
import FieldTaskStatus from "./system/task/status/status";
import FieldProjectOwner from "./system/project/owner/project-owner";
import FieldEventAssignedUser from "./system/event/assigned-user/assigned-user";
import FieldTaskAssignedToUser from "./system/task/user/assigned-to-user/assigned-to-user";
import FieldRating from "./generic/rating/rating";
import FieldProjectIcon from "./system/project/icon/icon";
import FieldDescriptionEditor from "./generic/message/message";
import FieldMultiselect from "./generic/multiselect/multiselect";
import FieldUsers from "./generic/users/users";
import FieldMoment from "./generic/datetime/moment/moment";
import FieldTaskId from "./system/task/short-id/task-id";
import FieldProjectEstimate from "./system/project/estimate/estimate";
import FieldTaskEstimate from "./system/task/estimate/estimate";
import FieldProjectProgress from "./system/project/progress/progress";
import FieldTaskProgress from "./system/task/progress/progress";
import FieldTaskStoryPoints from "./system/task/story-points/story-points";
import FieldCrmContactsTotal from "./system/crm/contacts-total/contacts-total";
import FieldTaskTimeReported from "./system/task/time-reported/time-reported";
import FieldDocumentType from "./system/document/type/type";
import FieldTaskTitle from "./system/task/title/title";
import FieldProjects from "./generic/entity/projects/projects";
import FieldTaskParent from "./system/task/parent/parent";
import FieldTags from "./generic/tags/tags";
import FieldDocumentAccessRead from "./system/document/access/access-read";
import FieldDocumentAccessWrite from "./system/document/access/access-write";
import FieldCrmContacts from "./system/crm/contacts/crm-contacts";
import FieldCrmAccount from "./system/crm/account/crm-account";
import FieldEventParent from "./system/event/parent/parent";
import FieldProjectSystemStatus from "./system/project/system-status/system-status";
import FieldProjectType from "./system/project/type/type";
import FieldProjectParent from "./system/project/parent/parent";
import FieldProjectStatus from "./system/project/status/project-status";
import FieldEventStartEnd from "./system/event/start-end/start-end";
import FieldEventStatus from "./system/event/status/status";
import FieldSystemLogStatus from "./system/logs/status/status";
import FieldProject from "./generic/entity/project/project";
import FieldProjectAccess from "./system/project/access/project-access";
import FieldProjectStartEnd from "./system/project/dates/start-end/start-end";
import FieldProjectDeadline from "./system/project/dates/deadline/deadline";
import FieldConfig from "./proto/field-config";
import FieldToDoListTemplate from "./system/todo/template/template";
import FieldProto from "./proto/field-proto";
import FieldTaskSystemStatus from "./system/task/system-status/system-status";
import {FieldType} from "./field-type";
import FieldSelectField from "./generic/select/select-field/select-field";
import FieldSelectFields from "./generic/select/select-fields/select-fields";
import FieldSelectGroupField from "./generic/select/select-group-field/select-group-field"
import FieldTaskStartEnd from "./system/task/date/start-end/start-end";
import FieldTaskLatestActivityMoment from "./system/task/date/latest-activity-moment/latest-activity-moment";
import FieldEventTypes from "./system/event/event-types/event-types";
import FieldTask from "./generic/task/task";
import FieldAgileReportDate from "./system/agile/report-date/report-date";
import FieldTime from "./generic/datetime/time/time";
import FieldCompanyUserRole from "./system/user/company-role/company-role";
import FieldCompanyUserWorkdayDuration from "./system/user/workday-duration/workday-duration";
import FieldCompanyUserRequiredReportTime from "./system/user/required-report-time/required-report-time";
import FieldCompanyUserSkills from "./system/user/skills/skills";
import FieldRadioGroup from "./generic/radio-group/radio-group";
import FieldBaseline from "./system/gantt/baseline/baseline";
import FieldCopyContent from "./generic/copy-content/copy-content";
import FieldExpenseCategory from "./system/expense/expense-category/expense-category";
import FieldExpenseProject from "./system/expense/project/project";
import FieldReminder from "./generic/reminder/reminder";
import FieldMeeting from "./generic/meeting/meeting";
import FieldEvent from "./generic/event/event";
import FieldTaskParentTask from "./system/task/parent-task/parent-task";
import FieldTimeOfDay from "./generic/datetime/time-of-day/time-of-day";
import FieldTaskPredecessors from "./system/task/predecessor/task-predecessor";
import FieldEstimatedCostInternal from "./generic/finance/cost-estimated/estimated-cost-internal"
import FieldEstimatedCostExternal from "./generic/finance/cost-estimated/estimated-cost-external"
import FieldProjectEstimateTasks from "./system/project/estimate/estimate-tasks"
import FieldCustomViewUserAccess from "./system/custom-view/user-access/user-access";
import FieldNavigationDisplayIn from "./system/navigation/display-in/display-in";
import FieldKeyboardShortcut from "./generic/keyboard-shortcut/keyboard-shortcut";
import FieldTimeDuration from "./generic/datetime/time-duration/time-duration"
import FieldTimeReportUser from "./system/time-report/user/time-report-user";
import FieldTimeReportDate from "./system/time-report/date/time-report-date";
import FieldProjectTemplate from "./system/project/template/template";
import FieldSelectView from "./generic/select/select-view/select-view"
import FieldPassword from "./generic/password/password";
import FieldItemModelStoryPointsCalculated from "./system/item-model/story-points-calculated/story-points-calculated";
import FieldTaskTypes from "./system/task/task-types/task-types";
import FieldItemModelTimeReportedCalculated
    from "./system/item-model/time-reported-calculated/time-reported-calculated";
import FieldItemModelCalculatedExpenses from "./system/item-model/calculated-expenses/calculated-expenses";
import FieldTaskDeadline from "./system/task/date/deadline/deadline";
import FieldTaskStartDate from "./system/task/date/start-date/start-date";
import FieldTaskEndDate from "./system/task/date/end-date/end-date";
import FieldTaskSchedule from "./system/task/date/schedule/schedule";
import FieldMessagesTotal from "./generic/total/messages/messages-total";
import FieldAttachmentsTotal from "./generic/total/attachments/attachments-total";
import FieldTaskDurationWorkdays from "./system/task/duration/duration-workdays";
import FieldTaskDurationCalendar from "./system/task/duration/duration-calendar";
import FieldItemModelCalculatedEstimate from "./system/item-model/calculated-estimate/calculated-estimate";
import FieldTaskCreatedBy from "./system/task/user/created-by/created-by";
import FieldTaskMomentCreated from "./system/task/date/moment-created/moment-created";
import FieldTaskMomentClosed from "./system/task/date/moment-closed/moment-closed";
import FieldItemModelCalculatedSpentEstimate
    from "./system/item-model/calculated-spent-estimate/calculated-spent-estimate";
import FieldTaskProgressItems from "./system/task/progress-items/progress-items";
import FieldItemModelCalculatedLaborCost from "./system/item-model/calculated-labor-cost/calculated-labor-cost";
import FieldItemModelCalculatedServiceCost from "./system/item-model/calculated-service-cost/calculated-service-cost";
import FieldTaskUsers from "./system/task/users/users";
import FieldProjectUsers from "./system/project/users/users";
import FieldProjectEndDate from "./system/project/dates/end/end-date";
import FieldProjectStartDate from "./system/project/dates/start/start-date";
import FieldProjectMomentCreated from "./system/project/dates/moment-created/moment-created";
import FieldProjectDurationCalendar from "./system/project/duration/duration-calendar";
import FieldProjectDurationWorkdays from "./system/project/duration/duration-workdays";
import FieldProjectProgressItems from "./system/project/progress-items/progress-items";
import FieldGoalHealth from "./system/goal/health/health";
import FieldIconWithColor from "./generic/icon-with-color/icon-with-color"
import FieldGoalType from "./system/goal/type/type"
import FieldAssignees from "./generic/assignees/assignees"
import FieldDateStartDue from "./generic/datetime/date-due/date-due"
import FieldGoalAssignees from "./system/goal/assignees/assignees"
import FieldEventDurationCalendar from "./system/event/duration/duration-calendar"
import FieldEventDurationWorkdays from "./system/event/duration/duration-workdays"
import FieldProjectTotalOpenAll from "./system/project/total-open-all/total-open-all"
import FieldProjectColor from "./system/project/color/color"
import FieldEventStartDate from "./system/event/start/start-date"
import FieldEventEndDate from "./system/event/end/end-date"
import FieldPredecessors from "./generic/dependency/predecessors/predecessors"
import FieldSuccessors from "./generic/dependency/successors/dependants"
import FieldTaskTags from "./system/task/tags/tags";
import FieldProjectProgressTasks from "./system/project/progress-tasks/progress-tasks";
import FieldBreakDuration from "./system/user/break-duration/break-duration";
import FieldTaskLeadTime from "./system/task/date/lead-time/lead-time"
import FieldTaskAge from "./system/task/date/age/age"
import FieldTimeReportIsBillable from "./system/time-report/is-billable/is-billable";
import FieldTimeSpent from "./generic/datetime/time-spent/time-spent";
import FieldTemplateParent from "./generic/template-parent/template-parent";
import FieldOffice from "./system/company/office/office";
import FieldEditDuration from "./system/company/edit-duration/edit-duration";
import FieldProjectName from "./system/project/name/project-name"
import FieldProjectColorIcon from "./system/project/color-icon/color-icon"
import FieldRequestFormParent from "./system/request-form/parent/parent"
import FieldCompanyUserWorkSchedule from "./system/user/work-schedule/work-schedule";
import FieldProjectPath from "./generic/project-path/project-path";
import FieldExpenseApprovalStatus from "./system/expense/approval-status/approval-status";
import FieldExpenseReimbursement from "./system/expense/reimbursement/reimbursement";
import FieldAttachments from "./generic/attachments/attachments";
import FieldReaction from "./generic/reaction/reaction";
import FieldVoting from "./generic/voting/voting";
import FieldRequestFormSelect from "./system/request-form/select/request-form-select";
import FieldDateRelative from "./generic/datetime/date-relative/date-relative"
import FieldDateRangeRelative from "./generic/datetime/date-range-relative/date-range-relative"
import FieldDateRangeRelativePeriod from "./generic/datetime/date-range-relative-period/date-range-relative-period";
import FieldExpenseAmount from "./system/expense/amount/amount"
import FieldExpenseUnits from "./system/expense/units/amount"
import FieldDatetime from "./generic/datetime/date-time/date-time";
import FieldAddress from "./generic/address/address";
import FieldAttachment from "./generic/attachment/attachment";
import FieldDepartment from "./generic/department/department";
import FieldViewForUser from "./system/user/view-for/view-for";
import FieldWorkspaceAccess from "./system/project/access/workpace-access";
import FieldProjectAccessMode from "./system/project/access-mode/access-mode";

export default class FieldsFactory {

    static get(fieldConfig:FieldConfig):FieldProto {

        const fieldType      = _.get(fieldConfig,'type') as FieldType
        const FieldClass     = FieldsFactory.getClass(fieldType)

        if (!FieldClass) {
            console.error('FieldsFactory: unknown type ({0})'.f(fieldType), fieldConfig)
            return new FieldProto(fieldConfig)
        }

        return new FieldClass(fieldConfig)
    }


    static getClass(fieldType:FieldType):typeof FieldProto|null {


        // Need refactor ? vmesto CASE -> Dictionary

        switch (fieldType) {

            case FieldType.ADDRESS                              : return FieldAddress
            case FieldType.ATTACHMENT                           : return FieldAttachment
            case FieldType.ATTACHMENTS                          : return FieldAttachments
            case FieldType.STRING                               : return FieldString
            case FieldType.PASSWORD                             : return FieldPassword
            case FieldType.TEXT                                 : return FieldText
            case FieldType.DROPDOWN                             : return FieldDropdown
            case FieldType.MULTISELECT                          : return FieldMultiselect
            case FieldType.RADIOGROUP                           : return FieldRadioGroup
            case FieldType.COLOR                                : return FieldColor
            case FieldType.USER                                 : return FieldUser
            case FieldType.USERS                                : return FieldUsers
            case FieldType.VIEW_FOR_USER                        : return FieldViewForUser
            case FieldType.DEPARTMENT                           : return FieldDepartment
            case FieldType.ASSIGNEES                            : return FieldAssignees
            case FieldType.PHONE                                : return FieldPhone
            case FieldType.EMAIL                                : return FieldEmail
            case FieldType.URL                                  : return FieldUrl
            case FieldType.CHECKBOX                             : return FieldCheckbox
            case FieldType.TOGGLE                               : return FieldToggle
            case FieldType.NUMBER                               : return FieldNumber
            case FieldType.CURRENCY                             : return FieldCurrency
            case FieldType.PERCENTAGE                           : return FieldPercentage
            case FieldType.DATE                                 : return FieldDate
            case FieldType.DATE_AND_TIME                        : return FieldDatetime
            case FieldType.DATE_RELATIVE                        : return FieldDateRelative
            case FieldType.DATE_RANGE                           : return FieldDateRange
            case FieldType.DATE_RANGE_RELATIVE                  : return FieldDateRangeRelative
            case FieldType.DATE_RANGE_RELATIVE_PERIOD           : return FieldDateRangeRelativePeriod
            case FieldType.DATE_START_DUE                       : return FieldDateStartDue
            case FieldType.RATING                               : return FieldRating
            case FieldType.RAG                                  : return FieldRAG
            case FieldType.FORMULA                              : return FieldFormula
            case FieldType.MOMENT                               : return FieldMoment
            case FieldType.TASK_DESCRIPTION_EDITOR              : return FieldDescriptionEditor
            case FieldType.PROJECTS                             : return FieldProjects
            case FieldType.TAGS                                 : return FieldTags
            case FieldType.SELECT_FIELD                         : return FieldSelectField
            case FieldType.SELECT_FIELDS                        : return FieldSelectFields
            case FieldType.SELECT_GROUP_FIELD                   : return FieldSelectGroupField
            case FieldType.SELECT_VIEW                          : return FieldSelectView
            case FieldType.TIME                                 : return FieldTime
            case FieldType.TIME_OF_DAY                          : return FieldTimeOfDay
            case FieldType.TIME_DURATION                        : return FieldTimeDuration
            case FieldType.TIME_SPENT                           : return FieldTimeSpent
            case FieldType.COPY_CONTENT                         : return FieldCopyContent
            case FieldType.KEYBOARD_SHORTCUT                    : return FieldKeyboardShortcut
            case FieldType.MESSAGES_TOTAL                       : return FieldMessagesTotal
            case FieldType.ATTACHMENTS_TOTAL                    : return FieldAttachmentsTotal
            case FieldType.ICON_WITH_COLOR                      : return FieldIconWithColor
            case FieldType.PREDECESSORS                         : return FieldPredecessors
            case FieldType.SUCCESSORS                           : return FieldSuccessors
            case FieldType.TEMPLATE_PARENT                      : return FieldTemplateParent
            case FieldType.BREAK_DURATION                       : return FieldBreakDuration
            case FieldType.REACTION                             : return FieldReaction
            case FieldType.VOTING                               : return FieldVoting

            // ENTITIES
            case FieldType.PROJECT                              : return FieldProject
            case FieldType.PROJECT_PATH                         : return FieldProjectPath
            case FieldType.TASK                                 : return FieldTask
            case FieldType.REMINDER                             : return FieldReminder
            case FieldType.MEETING                              : return FieldMeeting
            case FieldType.EVENT                                : return FieldEvent

            // MULTI ENTITIES FIELDS for table etc - at the moment used with ItemModel
            case FieldType.ITEM_MODEL_STORY_POINTS_CALCULATED   : return FieldItemModelStoryPointsCalculated
            case FieldType.ITEM_MODEL_CALCULATED_TIME_REPORTS   : return FieldItemModelTimeReportedCalculated
            case FieldType.ITEM_MODEL_CALCULATED_EXPENSES       : return FieldItemModelCalculatedExpenses
            case FieldType.ITEM_MODEL_CALCULATED_ESTIMATE       : return FieldItemModelCalculatedEstimate
            case FieldType.ITEM_MODEL_CALCULATED_SPENT_ESTIMATE : return FieldItemModelCalculatedSpentEstimate
            case FieldType.ITEM_MODEL_CALCULATED_LABOR_COST     : return FieldItemModelCalculatedLaborCost
            case FieldType.ITEM_MODEL_CALCULATED_SERVICE_COST   : return FieldItemModelCalculatedServiceCost


            // Task
            case FieldType.TASK_ID                              : return FieldTaskId
            case FieldType.TASK_TITLE                           : return FieldTaskTitle
            case FieldType.TASK_TYPE                            : return FieldTaskType
            case FieldType.TASK_TYPES                           : return FieldTaskTypes         // vot nefiga ne task - eto selectTaskTypes ... on generic dolzen bit'
            case FieldType.TASK_PROJECT                         : return FieldTaskParent
            case FieldType.TASK_PARENT_TASK                     : return FieldTaskParentTask
            case FieldType.TASK_STATUS                          : return FieldTaskStatus
            case FieldType.TASK_SYSTEM_STATUS                   : return FieldTaskSystemStatus
            case FieldType.TASK_PRIORITY                        : return FieldTaskPriority
            case FieldType.TASK_STORY_POINTS                    : return FieldTaskStoryPoints
            case FieldType.TASK_ACTION_REQUIRED                 : return FieldTaskActionRequiredUser
            case FieldType.TASK_ASSIGNED_TO                     : return FieldTaskAssignedToUser
            case FieldType.TASK_TIME_REPORTED                   : return FieldTaskTimeReported
            case FieldType.TASK_ESTIMATE                        : return FieldTaskEstimate
            case FieldType.TASK_PROGRESS                        : return FieldTaskProgress
            case FieldType.TASK_PROGRESS_ITEMS                  : return FieldTaskProgressItems
            case FieldType.TASK_START_END                       : return FieldTaskStartEnd
            case FieldType.TASK_LATEST_ACTIVITY_MOMENT          : return FieldTaskLatestActivityMoment
            case FieldType.TASK_PREDECESSOR_TASKS               : return FieldTaskPredecessors
            case FieldType.TASK_DEADLINE                        : return FieldTaskDeadline
            case FieldType.TASK_START_DATE                      : return FieldTaskStartDate
            case FieldType.TASK_END_DATE                        : return FieldTaskEndDate
            case FieldType.TASK_SCHEDULE                        : return FieldTaskSchedule
            case FieldType.TASK_DURATION_WORKDAYS               : return FieldTaskDurationWorkdays
            case FieldType.TASK_DURATION_CALENDAR               : return FieldTaskDurationCalendar
            case FieldType.TASK_CREATED_BY                      : return FieldTaskCreatedBy
            case FieldType.TASK_MOMENT_CREATED                  : return FieldTaskMomentCreated
            case FieldType.TASK_MOMENT_CLOSED                   : return FieldTaskMomentClosed
            case FieldType.TASK_USERS                           : return FieldTaskUsers
            case FieldType.TASK_TAGS                            : return FieldTaskTags
            case FieldType.TASK_LEAD_TIME                       : return FieldTaskLeadTime
            case FieldType.TASK_AGE                             : return FieldTaskAge

            // Project
            case FieldType.PROJECT_NAME                         : return FieldProjectName
            case FieldType.PROJECT_STATUS                       : return FieldProjectStatus
            case FieldType.PROJECT_SYSTEM_STATUS                : return FieldProjectSystemStatus
            case FieldType.PROJECT_OWNER                        : return FieldProjectOwner
            case FieldType.PROJECT_MOMENT_CREATED               : return FieldProjectMomentCreated
            case FieldType.PROJECT_START                        : return FieldProjectStartDate
            case FieldType.PROJECT_END                          : return FieldProjectEndDate
            case FieldType.PROJECT_START_END                    : return FieldProjectStartEnd
            case FieldType.PROJECT_DEADLINE                     : return FieldProjectDeadline
            case FieldType.PROJECT_ACCESS                       : return FieldProjectAccess
            case FieldType.WORKSPACE_ACCESS                     : return FieldWorkspaceAccess
            case FieldType.PROJECT_ICON                         : return FieldProjectIcon
            case FieldType.PROJECT_HEALTH                       : return FieldProjectHealth
            case FieldType.PROJECT_PARENT                       : return FieldProjectParent
            case FieldType.PROJECT_TYPE                         : return FieldProjectType
            case FieldType.PROJECT_PRIORITY                     : return FieldProjectPriority
            case FieldType.PROJECT_ESTIMATE                     : return FieldProjectEstimate
            case FieldType.PROJECT_ESTIMATE_TASKS               : return FieldProjectEstimateTasks
            case FieldType.PROJECT_PROGRESS                     : return FieldProjectProgress
            case FieldType.PROJECT_TEMPLATE                     : return FieldProjectTemplate
            case FieldType.PROJECT_USERS                        : return FieldProjectUsers
            case FieldType.PROJECT_DURATION_WORKDAYS            : return FieldProjectDurationWorkdays
            case FieldType.PROJECT_DURATION_CALENDAR            : return FieldProjectDurationCalendar
            case FieldType.PROJECT_PROGRESS_ITEMS               : return FieldProjectProgressItems
            case FieldType.PROJECT_TOTAL_OPEN_ALL               : return FieldProjectTotalOpenAll
            case FieldType.PROJECT_COLOR                        : return FieldProjectColor
            case FieldType.PROJECT_PROGRESS_TASKS               : return FieldProjectProgressTasks
            case FieldType.PROJECT_COLOR_ICON                   : return FieldProjectColorIcon
            case FieldType.PROJECT_ACCESS_MODE                  : return FieldProjectAccessMode

            // CRM
            case FieldType.CRM_ACCOUNT                          : return FieldCrmAccount
            case FieldType.CRM_CONTACT                          : return FieldCrmContact
            case FieldType.CRM_CONTACTS                         : return FieldCrmContacts
            case FieldType.CRM_CONTACT_TYPE                     : return FieldCrmContactType
            case FieldType.CRM_CONTACTS_TOTAL                   : return FieldCrmContactsTotal

            // Event
            case FieldType.EVENT_START                          : return FieldEventStartDate
            case FieldType.EVENT_END                            : return FieldEventEndDate
            case FieldType.EVENT_START_END                      : return FieldEventStartEnd
            case FieldType.EVENT_PARENT                         : return FieldEventParent
            case FieldType.EVENT_STATUS                         : return FieldEventStatus
            case FieldType.EVENT_ASSIGNED_USER                  : return FieldEventAssignedUser
            case FieldType.EVENT_TYPE                           : return FieldEventType
            case FieldType.EVENT_TYPES                          : return FieldEventTypes
            case FieldType.EVENT_DURATION_WORKDAYS              : return FieldEventDurationWorkdays
            case FieldType.EVENT_DURATION_CALENDAR              : return FieldEventDurationCalendar

            // Document
            case FieldType.DOCUMENT_TYPE                        : return FieldDocumentType
            case FieldType.DOCUMENT_ACCESS_READ                 : return FieldDocumentAccessRead
            case FieldType.DOCUMENT_ACCESS_WRITE                : return FieldDocumentAccessWrite

            // System Log
            case FieldType.SYSTEM_LOG_STATUS                    : return FieldSystemLogStatus

            // TO-DO Lists
            case FieldType.TODO_LIST_TEMPLATE                   : return FieldToDoListTemplate

            // Agile
            case FieldType.AGILE_REPORT_DATE                    : return FieldAgileReportDate

            // Company User
            case FieldType.COMPANY_USER_ROLE                    : return FieldCompanyUserRole
            case FieldType.COMPANY_USER_WORKDAY_DURATION        : return FieldCompanyUserWorkdayDuration
            case FieldType.COMPANY_USER_REQUIRED_REPORT_TIME    : return FieldCompanyUserRequiredReportTime
            case FieldType.COMPANY_USER_SKILLS                  : return FieldCompanyUserSkills
            case FieldType.COMPANY_USER_WORK_SCHEDULE           : return FieldCompanyUserWorkSchedule


            // Gantt baseline
            case FieldType.BASELINE                             : return FieldBaseline

            // Cost
            case FieldType.ESTIMATED_COST_INTERNAL              : return FieldEstimatedCostInternal
            case FieldType.ESTIMATED_COST_EXTERNAL              : return FieldEstimatedCostExternal

            // Expense
            case FieldType.EXPENSE_CATEGORY                     : return FieldExpenseCategory
            case FieldType.EXPENSE_PROJECT                      : return FieldExpenseProject
            case FieldType.EXPENSE_APPROVAL_STATUS              : return FieldExpenseApprovalStatus
            case FieldType.EXPENSE_REIMBURSEMENT                : return FieldExpenseReimbursement
            case FieldType.EXPENSE_AMOUNT                       : return FieldExpenseAmount
            case FieldType.EXPENSE_UNITS                        : return FieldExpenseUnits

            // CustomView
            case FieldType.CUSTOM_VIEW_USER_ACCESS              : return FieldCustomViewUserAccess

            // Navigation
            case FieldType.NAVIGATION_DISPLAY_IN                : return FieldNavigationDisplayIn

            // Time report
            case FieldType.TIME_REPORT_USER                     : return FieldTimeReportUser
            case FieldType.TIME_REPORT_DATE                     : return FieldTimeReportDate
            case FieldType.TIME_REPORT_IS_BILLABLE              : return FieldTimeReportIsBillable

            // Goals
            case FieldType.GOAL_HEALTH                          : return FieldGoalHealth
            case FieldType.GOAL_TYPE                            : return FieldGoalType
            case FieldType.GOAL_ASSIGNEES                       : return FieldGoalAssignees

            // Public forms & requests
            case FieldType.REQUEST_FORM_PARENT                  : return FieldRequestFormParent
            case FieldType.REQUEST_FORM_SELECT                  : return FieldRequestFormSelect

            // COMPANY related
            case FieldType.COMPANY_OFFICE                       : return FieldOffice
            case FieldType.EDIT_DURATION                        : return FieldEditDuration


            default:
                console.error('FieldsFactory: unknown type ({0})'.f(fieldType))
                return null
        }
    }

}
